import { render, staticRenderFns } from "./StockMarketItem.vue?vue&type=template&id=01b3edfc"
import script from "./StockMarketItem.vue?vue&type=script&lang=js"
export * from "./StockMarketItem.vue?vue&type=script&lang=js"
import style0 from "./StockMarketItem.vue?vue&type=style&index=0&id=01b3edfc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports